import type { ProductType } from "src/app/paywall/two-prod/hooks/use-paywall-state";

const EXPRESS_CHECKOUT_ALLOWLIST = new Set<string>([
  "unlimitedRx",
  "pediatricSupport",
  "pediatricSupportSingle",
  "pediatricSupportFamily",
  "kinsaClinic",
]);

/** Express checkout (Apple Pay / Google Pay) is only available for certain products */
export function supportsExpressCheckout(
  product: ProductType | string
): boolean {
  return EXPRESS_CHECKOUT_ALLOWLIST.has(product);
}
